<div class="table-responsive">
  <button mat-raised-button class="createButton" color="accent" (click)="createItem()">Artikel erstellen</button>
  <table mat-table [dataSource]="items" class="mat-elevation-z8">
    <!-- Columns for Order interface -->
    <ng-container matColumnDef="itemNo">
      <th mat-header-cell *matHeaderCellDef>Nummer</th>
      <td mat-cell *matCellDef="let item">{{ item.itemNo }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Bezeichnung</th>
      <td mat-cell *matCellDef="let item">{{ item.name }}</td>
    </ng-container>

    <ng-container matColumnDef="price">
      <th mat-header-cell *matHeaderCellDef>Preis</th>
      <td mat-cell *matCellDef="let item">{{ item.price | currency: 'EUR': 'symbol' }}</td>
    </ng-container>

    <ng-container matColumnDef="categoryIdentifier">
      <th mat-header-cell *matHeaderCellDef>Kategorie</th>
      <td mat-cell *matCellDef="let item">{{ item.categoryName }}</td>
    </ng-container>

    <ng-container matColumnDef="printCategoryIdentifier">
      <th mat-header-cell *matHeaderCellDef>Druckkategorie-ID</th>
      <td mat-cell *matCellDef="let item">{{ item.printCategoryIdentifier }}</td>
    </ng-container>

    <ng-container matColumnDef="sortId">
      <th mat-header-cell *matHeaderCellDef>Sortierungsnummer</th>
      <td mat-cell *matCellDef="let item">{{ item.sortId }}</td>
    </ng-container>

    <ng-container matColumnDef="remainingQuantity">
      <th mat-header-cell *matHeaderCellDef>Restmenge</th>
      <td mat-cell *matCellDef="let item">{{ (item.infiniteQuantity) ? '∞' : item.remainingQuantity }}</td>
    </ng-container>

    <ng-container matColumnDef="enabled">
      <th mat-header-cell *matHeaderCellDef>Aktiv</th>
      <td mat-cell *matCellDef="let item">{{ item.enabled | yesNo }}</td>
    </ng-container>

    <ng-container matColumnDef="details">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <button mat-icon-button (click)="showItemDetails(item)">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <button mat-icon-button (click)="deleteItem(item)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Define the displayed columns order -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let item; columns: displayedColumns;"></tr>
  </table>
</div>
